// <div ng-controller="FrameworkHelperCtrl as frameworkHelperCtrl"></div>

// no script tag in head is needed, this should immediately start working if you are running ./gradlew gulp_watch

const FrameworkHelperCtrl = function ($scope, $timeout) {
  $scope.showFrameworkDetails = function() {
    console.log('showFrameworkDetails()')
    var frameworkLoadingBox = document.getElementById('frameworkLoadingBox');
    if (frameworkLoadingBox != null) {
        frameworkLoadingBox.style.display = "none";
    }
    var frameworkWrapper = document.getElementById('frameworkWrapper');
    if (frameworkWrapper != null) {
        frameworkWrapper.style.display = "";
    }
  };
  $scope.hideFrameworkDetails = function() {
    console.log('hideFrameworkDetails()')
    var frameworkLoadingBox = document.getElementById('frameworkLoadingBox');
    if (frameworkLoadingBox != null) {
        frameworkLoadingBox.style.display = "";

        var frameworkId = document.getElementById("frameworkId");
        if (frameworkId != null) {
            if (frameworkId.value === '') {
                frameworkLoadingBox.style.display = "none";
            }
        }
    }

    var frameworkWrapper = document.getElementById('frameworkWrapper');
    if (frameworkWrapper != null) {
        frameworkWrapper.style.display = "none";
    }
  };

  return $scope
}

ExampleCtrl.$inject = ['$scope', '$timeout']
angular.module('app').controller('FrameworkHelperCtrl', FrameworkHelperCtrl); // one semi at end of file is a must or lots of things break!
